// @flow
import React from 'react';
import ListModel from 'Stores/ListModel';
import TeaserModel from 'Stores/TeaserModel';
import Carousel from 'Components/Carousel';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import Item from './item';
import DealerModel from 'Stores/DealerModel';

const cx = classNames.bind(styles);

type Props = {
  teasers: Array<Object>,
  type: string,
  onOpenContact: () => void,
  deeplinkId?: number,
  dealer: DealerModel,
};

type State = {
  teasers: ListModel,
  stage: boolean,
};

export default class Teaser extends React.Component<Props, State> {
  state = {
    teasers: new ListModel(),
    stage: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      teasers: new ListModel(props.teasers, TeaserModel),
      stage: this.props.type === 'mask_teaser_area_stage',
      currentIndex: 0,
      consumptionTexts: [],
    };
  }

  renderTeasers = (teasers) => {
    const { onOpenContact, consumptionText, dealer } = this.props;
    const { consumptionTexts } = this.state;

    return teasers.reduce((acc, cur) => {
      if (cur.hidden) {
        return acc;
      }

      return [
        ...acc,
        <Item
          dealer={dealer}
          teaser={cur}
          stage={this.state.stage}
          onOpenContact={onOpenContact}
          key={cur.id}
          id="teaser"
          consumption={consumptionText || consumptionTexts[cur.id]}
        />,
      ];
    }, []);
  };

  updateCurrentIndex = (currentIndex) => {
    this.setState({
      currentIndex: currentIndex - 1,
    });
  };

  render() {
    const { teasers } = this.state;
    const { deeplinkId } = this.props;

    if (teasers.items.length > 1) {
      return (
        <div className={cx({ black: !this.state.stage })} id={deeplinkId}>
          <Carousel
            id={`teaser-${deeplinkId}`}
            showArrows={false}
            showIndicators={true}
            showStatus={false}
            autoPlay
            transitionTime={700}
            updateCurrentIndex={this.updateCurrentIndex}
            wholeAreaIsClickable
            postionTeaser={true}
          >
            {this.renderTeasers(teasers)}
          </Carousel>
        </div>
      );
    }
    return <div id={deeplinkId}>{this.renderTeasers(teasers)}</div>;
  }
}
